<template>
  <div>
    <b-modal
      id="config-modal"
      :scrollable="true"
      :title="mode === 'add' ? 'Add New Email' : 'Edit Config'"
      header-bg-variant="success"
      size="md"
      centered
      hide-footer>
      <b-form-group label="Email">
        <b-input v-model="localForm.email" size="sm" />
      </b-form-group>
      <b-form-group label="Name">
        <b-input v-model="localForm.name" size="sm" />
      </b-form-group>
      <b-form-group label="EV Vehicles">
        <v-select
          v-model="localForm.itemIds"
          :options="vehicles"
          :reduce="vehicle => vehicle.itemId"
          label="licensePlate"
          multiple>
          <template #selected-option="{ licensePlate, name }">
            {{ `${licensePlate} - ${name}`}}
          </template>
        </v-select>
      </b-form-group>
      <hr>
      <div class="text-right">
        <b-btn
          :disabled="isSubmitting"
          variant="primary"
          @click="handleSubmit">Save</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'ElectricVehiclesConfigModal',
  components: {
    vSelect
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    isSubmitting: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => {}
    },
    vehicles: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      localForm: {
        email: undefined,
        name: undefined,
        itemIds: []
      }
    }
  },
  watch: {
    config(nv) {
      if (nv) {
        this.localForm.receiverId = nv.receiverId
        this.localForm.itemIds = nv.evVehicles.map((v) => {
          const licensePlate = v.split(',')[0]
          const selected = this.vehicles.find((o) => o.licensePlate === licensePlate)
          return selected.itemId
        })
        this.localForm.email = nv.emailAddress
        this.localForm.name = nv.name
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', this.localForm)
    }
  }
}
</script>

<style lang="scss">
@import 'vue-select/src/scss/vue-select.scss';
</style>
